import config from '../config';
import {
  authHeader,
  customFetch,
  handleResponse,
  jsonHeader,
  commonRequestOptions,
  subjects,
} from '../helpers';

const endpointPath = config.api.API_URL + '/schedule';

export const scheduleService = {
  getAll,
  getById,
  getByTaskId,
  create,
  update,
  run,
  checkDestroy,
  destroy,
};

function getAll(signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/all`, requestOptions, signal).then(handleResponse);
}

/**
 * Fetches all schedules assigned to a specific task.
 * @param {number} id - Task ID.
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ schedules: Array }>}
 */
function getByTaskId(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/task/${id}`, requestOptions, signal).then(handleResponse);
}

function getById(id, signal) {
  const requestOptions = { method: 'GET', headers: authHeader(), ...commonRequestOptions() };
  return customFetch(`${endpointPath}/${id}`, requestOptions, signal)
    .then(handleResponse)
    .then(res => {
      if (!res) return;
      subjects.currentSchedule?.next(res?.schedules[0] || { schedule_id: id });
      return res;
    });
}

function create(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

function update(items, signal) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}

/**
 * Enqueues all eligible tasks assigned to the given schedule(s) for manual execution.
 * @param {number[]} scheduleIds - Array of schedule IDs to run.
 * @param {AbortSignal} [signal]
 * @returns {Promise<{ ok: boolean, message: string, scheduleIds: number[], taskIds: number[], jobIds: number[] }>}
 */
function run(scheduleIds, signal) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify({ schedule_ids: scheduleIds }),
  };
  return customFetch(`${endpointPath}/run`, requestOptions, signal).then(handleResponse);
}

function checkDestroy(items, signal) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(`${endpointPath}/check_delete`, requestOptions, signal).then(handleResponse);
}

function destroy(items, signal) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), ...jsonHeader() },
    ...commonRequestOptions(),
    body: JSON.stringify(items),
  };
  return customFetch(`${endpointPath}`, requestOptions, signal).then(handleResponse);
}
